import { useCachedAuthToken } from '@tribeplatform/react-sdk/hooks';
import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokenKey } from '../../utils/keys';
export const useAuthToken = (options) => {
    const { useQueryOptions, fields = 'default' } = options || {};
    const { client, config, onTokenUpdate } = useTribeClient();
    const authTokenKey = getAuthTokenKey({ fields });
    const { networkDomain } = config || {};
    return useQuery(authTokenKey, () => client.getTokens({ networkDomain }, fields), {
        placeholderData: useCachedAuthToken(),
        onSuccess: data => {
            client.setToken(data.accessToken);
            if (typeof onTokenUpdate === 'function') {
                onTokenUpdate(data);
            }
            if (typeof (useQueryOptions === null || useQueryOptions === void 0 ? void 0 : useQueryOptions.onSuccess) === 'function') {
                useQueryOptions.onSuccess(data);
            }
        },
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useAuthToken.js.map